import { useState, useEffect } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { AppWatch } from '@wajeez-web/core/api-base';
import account from '../../../../../shared-assets/images/account.png';
import independent from '../../../../../shared-assets/images/independent.png';
import listening from '../../../../../shared-assets/images/listening.png';
import topRated from '../../../../../shared-assets/images/top-rated.png';
import { useContentSelector } from '@wajeez-web/stores/content';
import { Select } from 'antd';
import FiltersSection from '../components/FiltersSection';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  ContentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import StatsGrid from '../components/StatsGrid';
import { Card, DateRangePickerInput } from '@wajeez-web/components/ui';

const contentTypesOptions = [
  {
    label: 'الكتب',
    value: AppWatch.ContentType.BOOK,
  },
  {
    label: 'التصنيفات',
    value: AppWatch.ContentType.CATEGORY,
  },
  {
    label: 'الروايات',
    value: AppWatch.ContentType.FICTION,
  },
  {
    label: 'بودكاست',
    value: AppWatch.ContentType.PODCAST,
  },
];

const ContentAnalysisPage = () => {
  const [dates, setDates] = useState<Date[]>([
    new Date(Date.now() - 30 * 24 * 3600 * 1000),
    new Date(),
  ]);
  const { lookups } = useContentSelector((c) => c.contentEntityType);
  const dispatch = useAppwatchDispatch();
  const [contentTypeSelected, setContentTypeSelected] =
    useState<AppWatch.ContentType>(AppWatch.ContentType.BOOK);
  const {
    contentTypeCount,
    contentTypeCountStatus,
    minutesListendToday,
    minutesListendTodayStatus,
    mostRatedContent,
    mostRatedContentStatus,
    topContent,
    topContentStatus,
  } = useAppwatchSelector((c) => c.contentAnalysis);
  useEffect(() => {
    lookups.length &&
      dispatch(
        ContentAnalysisActions.getContentTypeCountAsync(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          lookups?.find(
            (l) => l.name == AppWatch.ContentType[contentTypeSelected]
          )?.id
        )
      );
  }, [contentTypeSelected, lookups]);
  useEffect(() => {
    dispatch(ContentAnalysisActions.getMinutesListendTodayAsync());
  }, []);
  useEffect(() => {
    dispatch(
      ContentAnalysisActions.getMostRatedContentAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        contentType: contentTypeSelected,
      })
    );
    dispatch(
      ContentAnalysisActions.getTopContentAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        contentType: contentTypeSelected,
      })
    );
  }, [dates, contentTypeSelected]);

  return (
    <PageLayoutsContainer
      title={`Content Analysis`}
      withoutRightPadding={false}
    >
      <div className="space-y-6 relative">
        <FiltersSection
          autoSelectDatesDirection="vertical"
          dates={dates}
          setDates={setDates}
          filter={
            <div className=" flex-row space-s-4 hidden md:flex">
              {contentTypesOptions.map((option) => (
                <div
                  className={`${
                    contentTypeSelected === option.value
                      ? 'bg-primary text-white'
                      : 'bg-gray-100'
                  } rounded-full px-2 cursor-pointer flex justify-center items-center w-[100px] h-[40px]`}
                  onClick={() => setContentTypeSelected(option.value)}
                >
                  {option.label}
                </div>
              ))}
            </div>
          }
          smFilter={
            <Select
              className="w-[100px]"
              size="large"
              value={contentTypeSelected}
              onChange={(value) => setContentTypeSelected(value)}
            >
              {contentTypesOptions.map((option) => (
                <Select.Option value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          }
        />

        <div className="grid grid-cols-1 md:grid-cols-2  gap-4">
          <div className="col-span-2">
            <StatsGrid
              data={[
                {
                  label: 'Minutes Listened Today',
                  value: minutesListendToday.toFixed(0) + ' دقيقة',
                  loading: minutesListendTodayStatus === 'loading',
                  icon: (
                    <img src={listening} alt="listening" className="w-[60px]" />
                  ),
                },
                {
                  label: 'Top Rated Content',
                  value: mostRatedContent?.title || '_',
                  loading: mostRatedContentStatus === 'loading',
                  icon: (
                    <img src={topRated} alt="topRated" className="w-[60px]" />
                  ),
                },
                {
                  label: 'Total Content',
                  value: contentTypeCount,
                  loading: contentTypeCountStatus === 'loading',
                  icon: (
                    <img src={account} alt="account" className="w-[60px]" />
                  ),
                },

                {
                  label: 'Top Content',
                  value: topContent?.title || '',
                  loading: topContentStatus === 'loading',
                  icon: (
                    <img
                      src={independent}
                      alt="independent"
                      className="w-[60px]"
                    />
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </PageLayoutsContainer>
  );
};

export default ContentAnalysisPage;
